import * as React from 'react';
import { Button, Grid, Modal, Text } from '@nextui-org/react';
import produce from 'immer';
import { StatusType } from '@src/generated/hooks';
import {
  AppFilterableList,
  AppFilterableListItem,
} from '@src/layouts/app/AppFilterableList';

interface ModalStatusSelectProps {
  onCancel: () => void;
  onOk: (selectedItems?: AppFilterableListItem[]) => void;
  selected: string[];
  visible: boolean;
}

/**
 * @name ModalStatusSelect
 * @description tbd...
 */
export function ModalStatusSelect(props: ModalStatusSelectProps) {
  const { onCancel, onOk, selected, visible } = props;

  // Hooks
  const [allItems, setAllItems] = React.useState<AppFilterableListItem[]>(
    Object.entries(StatusType)
      .map(([key, value]) => ({
        id: key,
        name: value,
      }))
      .map(({ id, name }) => {
        return {
          id,
          name,
          selected: selected.includes(name),
        };
      }),
  );

  // Handlers
  const onItemSelect = (selectedItems?: AppFilterableListItem[]) => {
    setAllItems(
      produce(allItems, (draft) => {
        if (selectedItems) {
          draft.forEach((item) => {
            item.selected = selectedItems.some((i) => i.id === item.id);
          });
        }
      }),
    );
  };

  return (
    <Modal
      blur
      preventClose
      aria-labelledby="modal-title"
      open={visible}
      onClose={() => onCancel()}
    >
      <Modal.Header>
        <Text id="modal-title" size={18} b>
          Select Status
        </Text>
      </Modal.Header>
      <Modal.Body>
        <AppFilterableList
          title="STATUSES"
          items={allItems}
          onItemsSelect={onItemSelect}
        />
      </Modal.Body>
      <Modal.Footer>
        <Grid.Container gap={1}>
          <Grid xs={6} justify="center">
            <Button
              auto
              light
              color="error"
              css={{ w: 'stretch' }}
              onPress={onCancel}
            >
              Cancel
            </Button>
          </Grid>
          <Grid xs={6} justify="center">
            <Button
              auto
              css={{ w: 'stretch' }}
              onPress={() => onOk(allItems.filter((i) => i.selected))}
            >
              Ok
            </Button>
          </Grid>
        </Grid.Container>
      </Modal.Footer>
    </Modal>
  );
}
